// import { Routes, Route } from "react-router-dom";

// import Footer from "./components/Footer";
// import Header from "./components/Header";
// import Hero from "./components/Hero";

// import Home from "./Pages/Home";
// import About from "./Pages/About";
// import Services from "./Pages/Service";
// import Contact from "./Pages/Contact";

// function App() {
//   return (
//     <>
//     <Header/>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/contact" element={<Contact />} />
//       </Routes>
//     </>
//   );
// }

// export default App;



import { Routes, Route } from "react-router-dom";

import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";

import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import Services from "./Pages/Services";
import ContactUs from "./Pages/ContactUs";
import Infrastructure from "./Pages/Infrastructure";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Header />
      <ScrollToTop/>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/contactus" element={<ContactUs/>}/>
      </Routes>

      <Footer />
    </>
  );
}

export default App;